import { Injectable } from '@angular/core';
import { AngularFirestore, CollectionReference } from '@angular/fire/compat/firestore';
import { DocumentReference, Timestamp } from '@angular/fire/firestore';
import { Customer } from '../models/customer.model';
import { Logger } from '../logger.service';

const log = new Logger('top-service');

export interface UserTop {
  id: string;
  customerId: DocumentReference<Customer>;
  isActive: boolean;
  email: string;
  phoneNumber: string;
  displayName: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

@Injectable({
  providedIn: 'root',
})
export class TopService {
  private collection: CollectionReference<UserTop>;

  constructor(private firestore: AngularFirestore) {
    this.collection = this.firestore.collection<UserTop>('users-top').ref;
  }

  async getTop(customerId: string): Promise<UserTop | null> {
    try {
      const ref = this.firestore.collection<Customer>('customers').doc(customerId).ref;
      const snap = await this.collection.where('customerId', '==', ref).get();
      if (snap.size) {
        return {
          ...snap.docs[0].data(),
          id: snap.docs[0].id,
        };
      }
    } catch (error) {
      log.error(error);
    }
    return null;
  }
}
